import { Box, Grid, Typography } from "@mui/material";

import styles from "../../../../../../assets/styles/componentStyles/organizationTeamsStyles/teams.module.scss";
import { organizationTeamsData } from "../../../../../../models/axiosModel";

interface TeamOverviewProps {
    team: organizationTeamsData;
}

const TeamOverview = ({ team }: TeamOverviewProps) => {
    const memberCount = team?.organization_team_users?.length ?? 0;

    return (
        <Box className={styles.teamDetailsOverview}>
            <Grid container spacing={3}>

                {/* Team Name */}
                <Grid item xs={12} sm={6}>
                    <Typography className={styles.teamDetailsOverviewLabel}>Team Name</Typography>
                    <Typography className={styles.teamDetailsOverviewValue}>
                        {team?.organization_team_name}
                    </Typography>
                </Grid>

                {/* Total Members */}
                <Grid item xs={12} sm={6}>
                    <Typography className={styles.teamDetailsOverviewLabel}>Total Members</Typography>
                    <Typography className={styles.teamDetailsOverviewValue}>
                        {memberCount}
                    </Typography>
                </Grid>

            </Grid>
        </Box>
    );
};

export default TeamOverview;
